import axios from 'axios';

import { handleAxiosError } from 'core/notifications';

const setReturnDestinationUrl = async ({ id, type }) => {
  const setDesitinationEndpoint = '/student/authentication/set_unauthenticated_post_authentication_destination';
  const csrfToken = document.querySelector('[name=csrf-token]').content;
  const destinationUrl = `/student/videos/${type}/${id}`;

  await axios.post(setDesitinationEndpoint, {
    authenticity_token: csrfToken,
    destination_url: destinationUrl,
  });
}

export default async ({ id, history, type, versionId }) => {
  let data;

  const url = `/api/learner/${type === 'live' ? 'live_videos' : 'videos'}/${id}/detail${versionId ? `?version_id=${versionId}` : ''}`;

  try {
    ({ data: { data } } = await axios.get(url));

    return {
      data: {
        ...data,
        vote_total: Math.max(data?.vote_total || 0, 0),
        actual_vote_total: data?.vote_total || 0,
      },
    };
  } catch (error) {

    const { status } = error.response;

    switch (status) {
      case 401:
        await setReturnDestinationUrl({ id, type });
        window.location.href = '/student/authentication/login';
        break;
      case 403:
        history.push('/student/videos/unauthorized');
        return;
      default:
        handleAxiosError(error);
    }

    throw error;
  }
};
